var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortDescending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0577 7.81662C17.1749 7.93383 17.3342 8 17.5 8C17.6658 8 17.8247 7.93415 17.9419 7.81694C18.0592 7.69973 18.125 7.54076 18.125 7.375C18.125 7.20924 18.0592 7.05027 17.9419 6.93306L14.8169 3.80806C14.6997 3.69085 14.5408 3.625 14.375 3.625C14.2092 3.625 14.0503 3.69085 13.9331 3.80806L10.8083 6.93282C10.6911 7.05003 10.625 7.20924 10.625 7.375C10.625 7.54076 10.6908 7.69973 10.8081 7.81694C10.9253 7.93415 11.0842 8 11.25 8C11.4158 8 11.5747 7.93415 11.6919 7.81694L14.375 5.13388L17.0577 7.81662Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.75V4.25C15 3.90482 14.7202 3.625 14.375 3.625C14.0298 3.625 13.75 3.90482 13.75 4.25V11.75C13.75 12.0952 14.0298 12.375 14.375 12.375C14.7202 12.375 15 12.0952 15 11.75Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.125H9.375C9.72018 11.125 10 10.8452 10 10.5C10 10.1548 9.72018 9.875 9.375 9.875H3.75C3.40482 9.875 3.125 10.1548 3.125 10.5C3.125 10.8452 3.40482 11.125 3.75 11.125Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.125H8.125C8.47018 6.125 8.75 5.84518 8.75 5.5C8.75 5.15482 8.47018 4.875 8.125 4.875H3.75C3.40482 4.875 3.125 5.15482 3.125 5.5C3.125 5.84518 3.40482 6.125 3.75 6.125Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.125H14.375C14.7202 16.125 15 15.8452 15 15.5C15 15.1548 14.7202 14.875 14.375 14.875H3.75C3.40482 14.875 3.125 15.1548 3.125 15.5C3.125 15.8452 3.40482 16.125 3.75 16.125Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescending);
export default __webpack_public_path__ + "static/media/sortDescending.521789b246bcc01aa215ab75e55faa18.svg";
export { ForwardRef as ReactComponent };